import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const MAX_HEIGHT = 224;

export const FloatingDropdown = ({ children, className = '', ...rest }) => {
  const anchorRef = useRef(null);
  const [style, setStyle] = useState(null);

  useLayoutEffect(() => {
    const update = () => {
      const parent = anchorRef.current?.parentElement;
      if (!parent) return;
      const r = parent.getBoundingClientRect();
      const spaceBelow = window.innerHeight - r.bottom;
      const openUp = spaceBelow < MAX_HEIGHT && r.top > spaceBelow;
      const width = Math.max(r.width, 260);
      setStyle({
        position: 'fixed',
        left: Math.max(8, r.right - width),
        width,
        maxHeight: Math.min(MAX_HEIGHT, (openUp ? r.top : spaceBelow) - 8),
        ...(openUp ? { bottom: window.innerHeight - r.top + 4 } : { top: r.bottom + 4 }),
        zIndex: 9999,
      });
    };
    update();
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <>
      <span ref={anchorRef} className="hidden" />
      {style && createPortal(
        <div dir="rtl" style={style} className={`overflow-y-auto ${className}`} {...rest}>{children}</div>,
        document.body
      )}
    </>
  );
};
